import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Roles from "src/components/panel/roles/Roles";
const RolesView = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t("roles_list_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("roles_list_title")}
          subtitle={t("roles_list_subtitle")}
        />

        <Roles />
      </Sidebar>
    </>
  );
};
export default RolesView;
